import { createFeatureSelector, createSelector } from '@ngrx/store';
import { customManufacturerCampaignFeatureKey, CustomManufacturerCampaignState, CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS, CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE, CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE, CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW } from './custom-manufacturer-campaign.reducer';


export const selectCustomManufacturerCampaignState = createFeatureSelector<CustomManufacturerCampaignState>(
    customManufacturerCampaignFeatureKey
  );

//******************************************************

export const selectManufacturerCampaignOverview = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW].manufacturerCampaignOverview
);

export const loadingManufacturerCampaignOverview = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW].isLoading
);

export const errorManufacturerCampaignOverview = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_OVERVIEW].error
);

//******************************************************

export const selectManufacturerCampaignDetails = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS].manufacturerCampaignDetails
);

export const loadingManufacturerCampaignDetails = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS].isLoading
);

export const errorManufacturerCampaignDetails = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS].error
);

//******************************************************

export const deleteSalesNotificationSuccess = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE].success
);

export const deleteSalesNotificationFailure = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_DELETE].error
);

//******************************************************

export const updateSalesNotificationSuccess = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE].success
);

export const updateSalesNotificationFailure = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE].error
);

export const updateSalesNotificationFailureMessage = createSelector(
    selectCustomManufacturerCampaignState,
    (state: CustomManufacturerCampaignState) =>
        state[CUSTOM_MANUFACTURER_CAMPAIGN_DETAILS_UPDATE].message
);